import {api} from "../../../api";

export const giftCardOrder = giveawayGiftCardData => {
    return api.post(`/v1/giveaway_orders`, giveawayGiftCardData);
}